import React from 'react'
import PropTypes from 'prop-types'

const IconCheck = ({ className }) => (
  <svg className={className} viewBox="0 0 24 24" width="17">
    <path d="M8.39 17.82L21.8 4.4a1.27 1.27 0 1 1 1.79 1.8L9.28 20.5c-.32.31-.77.42-1.17.32a1.26 1.26 0 0 1-.62-.31L.34 13.35a1.27 1.27 0 0 1 1.79-1.79l6.26 6.26z" />
  </svg>
)

IconCheck.propTypes = {
  className: PropTypes.string,
}

IconCheck.defaultProps = {
  className: '',
}

export default IconCheck
